export const APP_CONSTANTS = {
	PORTAL_NAME: "E-Mail-Verifikation",
	MAX_LENGTH_SHORT: 20,
	MAX_LENGTH_MEDIUM: 40,
	TIMEOUT_DEFAULT: 10000, // 10 secs
	TIMEOUT_MEDIUM: 30000, // 30 secs
	TIMEOUT_LONG: 60000, // 60 secs
	TIMEOUT_API_RESPONSE: 12000, // 12 secs
	SMS_RESEND_OTP_TIMEOUT: 3, // in minutes
	SMS_OTP_LENGTH: 6,
	SESSION_DURATION: 60,
	REGEX_DATE_PICKER: /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/,
	STORAGE_CONSTANTS: {
		LANGUAGE: "language",
		USER_DETAILS: "user_details",
		CASE_ID: "caseID",
		VID: "vid",
		SOURCE_ID: "sid",
		SCENARIO_DECLINE: "result"
	},
	ERROR_MESSAGES: {
		SERVER_ERROR:
			"Oops! Something went wrong. Please try again later",
		GENERIC_ERROR:
			"Oops! Something went wrong. Please try again later",
		BAD_REQUEST_ERROR:
			"Looks like something is wrong with your input. Please check and try again"
	},
	URL: {
		HOME: "/email-verifikation"
	},
	LINK: {
		TELEKOM: "https://www.telekom.de",
		KUNDENCENTER: "https://www.telekom.de/mein-magenta-kundencenter"
	},
	MAX_VERIFICATION_ATTEMPTS: {
		CUSTOMER_NUMBER: 5,
		SMS: 3,
		IBAN: 5,
		ZIP_CODE: 5,
		BIRTH_DATE: 5
	}
};
